import type { Ref } from 'vue'
import { computed, ref, watch } from 'vue'
import type { TableData } from '../types'
export const useSelection = ({
  selection, // 全部选中数据
  allEnabledSelectionRows, // 当前列可选数据
  emit
}: {
  selection: Ref<TableData[]>
  allEnabledSelectionRows: Ref<TableData[]>
  emit: any
}) => {
  const innerSelection = ref(selection.value ?? [])
  const keepSelection = computed(() => innerSelection.value.filter((row) => row.disabled))
  // 选中行
  const selectionRows = computed(() => innerSelection.value)
  // 选中行的key
  const selectionRowKeys = computed(() => {
    return innerSelection.value.map((row) => row.key)
  })
  // todo 下一步启用
  const useSelectedKeys = ref<(string | number)[]>([])

  const toggleSelectAll = (checked: boolean) => {
    // console.log('榉木接地----', allEnabledSelectionRows.value, keepSelection.value)
    // 当前列全部数据，包含disabled
    const _allEnabledSelectionRows = [...allEnabledSelectionRows.value, ...keepSelection.value]
    // 全选，则用当前页中所有可选行，不含disabled，都则使用disabled行
    const _selection = checked ? _allEnabledSelectionRows : [...keepSelection.value]
    // console.log('useSelectedKeys', useSelectedKeys.value)
    let originSelection = [...innerSelection.value]
    // 下面要处理全选数据插入的问题，同时需要处理取消全选数据剔除的问题
    // 如果全选
    if (checked) {
      _selection.map((row) => {
        // 如果全部选中项中不包含当前页的数据，则插入
        if (!selectionRowKeys.value.includes(row.key)) {
          originSelection.push(row)
        }
      })
    } else {
      // 取消全选
      _allEnabledSelectionRows.map((row) => {
        // console.log('徐丽华~~~~', row.disabled)
        if (selectionRowKeys.value.includes(row.key) && !row.disabled) {
          originSelection = originSelection.filter((r) => r.key !== row.key)
        }
      })
      _selection.map((row) => {
        if (!selectionRowKeys.value.includes(row.key)) {
          originSelection.push(row)
        }
      })
    }
    innerSelection.value = originSelection
    // TODO 没有绑定事件不需要触发事件函数
    emit('update:selection', originSelection)
    emit('selection-change', originSelection)
  }

  /**
   * Table Checkbox全选
   * @param checked
   */
  const selectAll = (checked: boolean) => {
    // console.log('selectAll', checked)
    toggleSelectAll(checked)
    emit('select-all', checked)
  }

  watch(selection, (val) => {
    innerSelection.value = val
  })

  /**
   * 切换选中状态
   * @param row
   * @param checked
   */
  const toggleSelect = (row: TableData, checked: boolean) => {
    let originSelection = [...innerSelection.value]
    if (checked) {
      if (row.key && !selectionRowKeys.value.includes(row.key)) {
        originSelection.push(row)
      }
    } else {
      // const index = originSelection.findIndex((r) => r === row)
      // if (index > -1) {
      //   originSelection.splice(index, 1)
      // }
      if (selectionRowKeys.value.includes(row.key) && !row.disabled) {
        originSelection = originSelection.filter((r) => r.key !== row.key)
      }
    }
    innerSelection.value = originSelection

    emit('update:selection', originSelection)
    emit('selection-change', originSelection)
  }

  return {
    toggleSelect,
    toggleSelectAll,
    selectAll,
    selectionRows,
    // 选中的Keys
    selectionRowKeys,
    useSelectedKeys
  }
}
